import React, {useEffect, useState} from 'react';
import Selector from "components/Form/Selector";
import IconName from "types/IconName";
import IconBadge from "components/IconBadge";

export type Item = {
    type?: string | null
    id: number | string // id must be unique
    name: string
    description?: string | null
    icon?: IconName | string
    indent?: boolean
}

type Props = {
    label?: string
    hint?: string
    isLoading?: boolean
    items: Array<Item>
    selectedIds?: Array<number | string>
    onChange: (items?: Array<Item>) => any
    required?: boolean
}

function MultiSelector(props: Props) {
    const {label, hint, isLoading, items, selectedIds, onChange} = props

    const [isReady, setIsReady] = useState<boolean>(false);
    const [selectedItems, setSelectedItems] = useState<Array<Item>>([])

    useEffect(() => {
        if(!isReady && !isLoading && !!selectedIds){
            setSelectedItems(items.filter(item => selectedIds.includes(item.id)))
            setIsReady(true)
        }

        if(isReady && selectedIds == null){
            setSelectedItems([])
        }
    }, [isReady, isLoading, items, selectedIds, selectedItems]);

    function selectItem(item: Item) {
        const selected = [...selectedItems, item]
        setSelectedItems(selected)

        onChange(selected)
    }

    function deselectItem(item: Item) {
        const selected = selectedItems.filter((selectedItem) => selectedItem.id !== item.id)
        setSelectedItems(selected)

        onChange(selected)
    }

    const availableItems = items.filter(item => !selectedItems.map(selectedItem => selectedItem.id).includes(item.id))

    return (
        <div>
            <Selector label={label} hint={hint} items={availableItems} onChange={selectItem} showSelected={false} isLoading={isLoading} required={props.required && !selectedItems.length}/>

            <div className="mt-2">
                {selectedItems.map((item) => (
                    <IconBadge
                        key={item.id}
                        color={IconBadge.colors.BRAND}
                        size={IconBadge.sizes.LARGE}
                        icon={item.icon}
                        text={item.name}
                        onDismiss={() => deselectItem(item)}
                    />
                ))}
            </div>
        </div>
    );
}

export default MultiSelector;